import React, { FC } from "react";
import { Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { DropdownParams } from "./types";
import { DropdownStyled } from "./elements";
const Dropdown: FC<DropdownParams> = (props) => {
  const { children, menu, disabled } = props;

  return (
    <DropdownStyled
      {...props}
      overlay={menu}
      trigger={["click"]}
      disabled={disabled || false}
    >
      <Button>
        {children} &nbsp;&nbsp; <DownOutlined style={{fontSize: '14px'}} />
      </Button>
    </DropdownStyled>
  );
};

export default Dropdown;
